import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { BusinessesRanking } from './businessesRanking'
import { MonthlyBalance } from './monthlyBalance'
import { MonthBalance } from './MonthBalance'
import { BsInfoCircle } from 'react-icons/bs'

import { useDispatch } from 'react-redux'
import { useState } from 'react'

///Styles
import { Container, Card, Title, FilterButton ,CloseButton } from './style'

export function RankingAndMonthlyBalance() {
    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()
    const dispatch = useDispatch()

    const [isMonthBalance, setIsMonthBalance] = useState({visible: false, month: ''});


    return(
            <Container>

                <Card 
                    onClick={() => dispatch({
                        type: 'OPEN_CENTRALIZEDMODAL', 
                        title: "Ranking", 
                        componentToShow: 'rankingDetailedInformations',
                        datasComponent: { 
                            endDate, 
                            startDate, 
                            business: listBusinessToFilter,
                            salesChannels: listSalesChannelsId
                        } 
                    })}
                    className='clickable'
                >
                    <BsInfoCircle />
                    <Title>Ranking</Title>

                    <BusinessesRanking />

                </Card>


                <Card className='clickable'>
                    {
                        isMonthBalance.visible ? 
                        <>
                            <FilterButton
                                onClick={() => dispatch({
                                    type: 'OPEN_CENTRALIZEDMODAL', 
                                    title: "Faturamento Diário", 
                                    componentToShow: 'dailyBalance',
                                    datasComponent: { 
                                        endDate, 
                                        startDate, 
                                        business: listBusinessToFilter,
                                        salesChannels: listSalesChannelsId,
                                        isMonthBalance: isMonthBalance
                                    } 
                                })}                            
                            >
                                <BsInfoCircle/>                           
                            </FilterButton>

                            <Title>Faturamento Diário ({isMonthBalance.month})</Title>
                            <CloseButton  
                                onClick={() => setIsMonthBalance({visible: false, month: ''})} 
                            >
                                &#10006;
                            </CloseButton>
                            <MonthBalance 
                                isMonthBalance={isMonthBalance}
                            />
                        </>
                        :
                        <>
                            <BsInfoCircle 
                                onClick={() => dispatch({
                                    type: 'OPEN_CENTRALIZEDMODAL', 
                                    title: "Faturamento Mensal", 
                                    componentToShow: 'monthlyBalance',
                                    datasComponent: { 
                                        endDate, 
                                        startDate, 
                                        business: listBusinessToFilter,
                                        salesChannels: listSalesChannelsId
                                    } 
                                })}
                            />
                            <Title>Faturamento Mensal</Title>
                            <MonthlyBalance 
                                setIsMonthBalance={setIsMonthBalance}
                            />
                        </>
                    }
                </Card>

            </Container>
    )
}
